import React from 'react';

import { trackProductFeaturesImpression } from '../tracking/productFeaturesEvents';
import type { ProductFeaturesProps } from './ProductFeatures';
import { ProductFeatures } from './ProductFeatures';

export const ProductFeaturesWithTracking = (props: ProductFeaturesProps) => {
  return (
    <ProductFeatures
      onVisible={(productFeaturesLabels) => trackProductFeaturesImpression(productFeaturesLabels)}
      {...props}
    />
  );
};
